import React, {
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
} from "react";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  Heading,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  RadioGroup,
  Stack,
  Step,
  StepDescription,
  StepIndicator,
  StepSeparator,
  StepStatus,
  StepTitle,
  Stepper,
  Td,
  Text,
  Th,
  Tr,
} from "@chakra-ui/react";
import ModalRight from "../../modal-right";
import SearchBar from "../../search-bar";
import PrimaryButton from "../../primary-button";
import PrimaryInput from "../../primary-input";
import DatePicker from "../../date-picker";
import SimpleTableInvestigation from "../../simple-table-investigation";

import {
  addVaccination,
  deleteVacinations,
  editVaccinations,
  FetchVaccinationDetails,
  getVaccineList,
} from "../../../middleware/services/messages";
import { format } from "date-fns";
import { actionAccessMain, getLoginID, handleAlphaDotAndSpace } from "../../../auth";
import moment from "moment";
import DatePickerQuick from "../date-picker-quick";
import { uploadImageInProfile } from "../../../middleware/services/profile";
import { AddMedicalRecord, GetLabTestName, GetTestResultByLabTestId } from "../../../middleware/services/visits/patient-overview";
import DynamicModal from "../../dynamic-modal";

const NoInvestigationDataScreen = forwardRef(
  (
    {
      width,
      height,
      patientId,
      patientCountryid,
      showErrorToast,
      showSuccessToast,
      showLoader,
      dismissLoader,
      fetchPatientHealthData,
      isNoData,
    },
    ref
  ) => {
    const openFromStartVisitOverview = () => {
      console.log("Function called!");
      openVaccinationsModal();
    };

    useImperativeHandle(ref, () => ({
      openFromStartVisitOverview,
    }));

    const [actionAccessPatients, setActionAccessPatients] = useState(null);
    useEffect(() => {
      setActionAccessPatients(actionAccessMain(4));
    }, []);

    const dynamicModal = React.useRef();
    const addCondition = React.useRef();
    const addCondition2 = React.useRef();

    const addCondition3 = React.useRef();

    const [data, setData] = useState("");
    var [conditionsList, setConditionsList] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [selectedConditions, setSelectedConditions] = useState([]);
    const [selectedDates, setSelectedDates] = useState({});
    const [selectedDueDates, setSelectedDueDates] = useState({});
    const [condition, setCondition] = useState("");
    const [vaccineid, setVaccineid] = useState("");
    const [idPatient, setIdPatient] = useState("");
    const [vaccineName, setVaccineName] = useState("");
    const [adminDate, setAdminDate] = useState("");
    const [dueDate, setDueDate] = useState("");

    const scrollDiv = useRef(null);
    const chatContainerRef = useRef(null);
    const [aianswers, setAIAnswers] = useState([]);
    const [remainingquestions, setRemainingQuestions] = useState([]);
    const [aiquestion, setAIAnalysis] = useState(null);
    const [AiInput, setAiInput] = useState(null);
    const [initialRender, setInitialRender] = useState(true);
    const [animate, setAnimate] = useState(false);
    const AIChatModel = useRef();

    const [typedCondition, setTypedCondition] = useState("");


    
    //state for document upload start ------------------------------
    const fileInputRef = useRef(null);
    const fileInputRefUpdate = useRef(null);
    
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    
    const [documentURLs, setDocumentURLs] = useState([]);
    const indexMap = {};
    const [documentURLForEdit, setDocumentURLForEdit] = useState([]);
    const [filenameforUpload, setFilenameforUpload] = useState([]);
    //state for document upload End ------------------------------


    let patientidFromLocal = patientId;

    const fetchMedicalConditionList = async () => {
      try {
        const result = await getVaccineList({
          type: "vaccine",
          patientid: patientidFromLocal,
        });
        if (result.output.result == "success") {
          setConditionsList(result.output.data);
        } else {
          showErrorToast("Something went wrong!");
        }
      } catch (error) {
        console.error("Error", error);
      }
    };

    const handleCheckboxChange = (condition) => {
      const isSelected = selectedConditions.some(
        (item) => item.condition_cd === condition.condition_cd
      );

      if (isSelected) {
        setSelectedConditions((prevConditions) =>
          prevConditions.filter(
            (item) => item.condition_cd !== condition.condition_cd
          )
        );

        setSelectedDates((prevDates) => {
          const updatedDates = { ...prevDates };
          delete updatedDates[condition.condition_cd]; // Remove the date for the deselected condition
          return updatedDates;
        });
        setSelectedDueDates((prevDates) => {
          const updatedDates = { ...prevDates };
          delete updatedDates[condition.condition_cd]; // Remove the date for the deselected condition
          return updatedDates;
        });
      } else {
         // If the condition is not selected, add it and set the date to the first date of the current month
             const now = new Date();
             const firstDateOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
             const formattedDate = format(firstDateOfMonth, "yyyy-MM-dd");
             setSelectedDates((prevDates) => ({
              ...prevDates,
              [condition.condition_cd]: formattedDate,
            }));
            setSelectedDueDates((prevDates) => ({
              ...prevDates,
              [condition.condition_cd]: formattedDate,
            }));

        setSelectedConditions([...selectedConditions, condition]);
      }
    };
    const [minDateState, setMinDateState] = useState("");
    const [maxDateState, setMaxDateState] = useState("");
    const handleDateChange = (conditionCd, date) => {
      const formattedDate = format(date, "yyyy-MM-dd");
      setMinDateState(date);
      setSelectedDates((prevDates) => ({
        ...prevDates,
        [conditionCd]: formattedDate,
      }));
    };
    const handleDueDateChange = (conditionCd, date) => {
      setMaxDateState(date);
      const formattedDate = format(date, "yyyy-MM-dd");
      setSelectedDueDates((prevDates) => ({
        ...prevDates,
        [conditionCd]: formattedDate,
      }));
    };

    var inputForAdd = {
      patientid: patientidFromLocal,
      doctorid: getLoginID(),
      vaccination: selectedConditions.map((condition, index) => ({
        vaccine_cd: condition.condition_cd,
        vaccinename: condition.condition,
        admindate: selectedDates[condition.condition_cd] || null,
        duedate: selectedDueDates[condition.condition_cd] || null,
        "documents": uploadedDocuments
        .filter((doc) => doc.condition_cd == condition.condition_cd)
        .map(({ condition_cd, filename }) => ({
          condition_cd,
          filename,
        })),
      })),
    };

    const AddMedicalConditions = () => {
      if (selectedConditions.length === 0 && typedCondition == "") {
        showErrorToast("Please Select a Vaccine to Continue");
      } else {
        // enter manually
        if (typedCondition !== "") {
          const newSelectedCondition = {
            condition: typedCondition,
            condition_cd: null,
            conditiontype: "other",
          };

          setSelectedConditions((prevConditions) => {
            // Filter out any existing condition with the same type
            const filteredConditions = prevConditions.filter(
              (item) => item?.conditiontype !== "other"
            );
            // Add the new condition
            return [...filteredConditions, newSelectedCondition];
          });
        }

        //--------------------------------
        // setSelectedDates({});
        // setSelectedDueDates({});
        addCondition2.current.openRight();
      }
    };

    const AddMedicalConditionsCall = () => {
      const addConditions = async () => {
        showLoader();
        try {
          const result = await addVaccination(inputForAdd);
          if (result.output.result == "success") {
            showSuccessToast("Successfully Added");
            if (scrollDiv.current) {
              scrollDiv.current.scrollTop = 0;
            }

            fetchPatientHealthData();

            addCondition2.current.closeRight();
            addCondition.current.closeRight();
          } else {
            showErrorToast("Something went wrong!");
          }
        } catch (error) {
          console.error("Error in DashboardIndex:", error);
        }
        dismissLoader();
      };

      const isDateMissing = selectedConditions.some(
        // (condition) => !selectedDates[condition.condition_cd] || !selectedDueDates[condition.condition_cd]
        (condition) => !selectedDates[condition.condition_cd]
      );

      if (isDateMissing) {
        showErrorToast("Please select admin date");
        return false;
      } else {
        addConditions();
      }
    };

    const openVaccinationsModal = () => {
      // if (conditionsList == null) {
      fetchMedicalConditionList();
      // }
      setSearchValue("");
      setSelectedConditions([]);
      setSelectedDueDates({});
      setTypedCondition("");
      addCondition.current.openRight();
    };

    const handleCondition = (e) => {
      const inputText = e.target.value;
      const maxLength = 80;

      if (inputText.length <= maxLength) {
        setTypedCondition(inputText);
      }
    };

    // upload document functionality start ------------------------------

  // ADD CODE - 
  const handleVaccineUpload = async (e) => {
    e.preventDefault();
    showLoader();
    if (e.target.files.length == 0) {
      dismissLoader();
      return;
    }
    const file2 = e.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file2.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
      setTimeout(() => {

        dismissLoader();
      }, 1000);
      return false;
    }
    const condition = e.target.getAttribute('data-vaccine');
    let condition_cd = e.target.getAttribute('data-vaccine-cd');
    if (condition_cd === "null") {
      condition_cd = null
    }
    const reader = new FileReader();
    reader.readAsDataURL(file2);
    const result = await uploadImageInProfile(file2, file2.name);
    const filename = result.name;
    setSelectedDates((prevDates) => ({
      ...prevDates,
      [condition]: {
        // date: prevDates[condition]?.date || "",
        fileName: filename,
      },
    }));
    setUploadedDocuments((prevDocuments) => [
      ...prevDocuments,
      { condition_cd, filename },
    ]);
    e.target.value = '';
    dismissLoader();

  };


  const addVaccineUploadDocument = (condition) => {
    // alert(condition.condition_cd)
    if (condition.condition_cd) {

      fileInputRef.current.setAttribute('data-vaccine-cd', condition.condition_cd);
      fileInputRef.current.setAttribute('data-vaccine', condition.condition);
      fileInputRef.current.click();

    } else {

      fileInputRef.current.setAttribute('data-vaccine-cd', null);
      fileInputRef.current.setAttribute('data-vaccine', "other");
      fileInputRef.current.click();
    }
  }

  useEffect(() => {
    setDocumentURLs(uploadedDocuments)
  }, [uploadedDocuments])

  const handleDelete = (index) => {
    const updatedUrls = [...uploadedDocuments];
    updatedUrls.splice(index, 1);
    setUploadedDocuments(updatedUrls);
  };
  const handleDeleteDocInEdit = (index) => {
    const updatedUrls = [...documentURLForEdit];
    updatedUrls.splice(index, 1);
    // setUploadedDocuments(updatedUrls);

    setDocumentURLForEdit(updatedUrls);

    if (updatedUrls != null) {

      setFilenameforUpload(updatedUrls?.map(doc => doc.documentname));
    }
  };

  // EDIT CODE -  ----
  const updateVaccineUploadDocument = (surgery_cd) => {

    fileInputRefUpdate.current.setAttribute('data-vaccine-cd', surgery_cd);
    fileInputRefUpdate.current.click();
  }
  const handleVaccineUploadUpdate = async (e) => {
    e.preventDefault();

    const vaccine_cd = e.target.getAttribute('data-vaccine-cd');
    showLoader();
    if (e.target.files.length == 0) {
      dismissLoader();
      return;
    }
    const file2 = e.target.files[0];
    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"];
    if (!allowedTypes.includes(file2.type)) {
      showErrorToast("Invalid file type. Please select a PNG, JPG or JPEG file.");
      setTimeout(() => {

        dismissLoader();
      }, 1000);
      return false;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file2);
    const result = await uploadImageInProfile(file2, file2.name);
    const filename = result.name;

    setFilenameforUpload(prevFilenames => [...prevFilenames, filename]);
    // setDocumentURLForEdit(prevFilenames => [...prevFilenames, { documenturl: filename, imagepath: "https://midocfileserver.blob.core.windows.net/midocdev/" }]);
    setDocumentURLForEdit(prevFilenames => [
      ...(prevFilenames ?? []),
      { documentname: filename, documenturl: filename, imagepath: "https://midocfileserver.blob.core.windows.net/midocdev/" }
    ]);

    e.target.value = '';
    showSuccessToast("Document Added Successfully.")
    dismissLoader();

  };


  // upload document functionality End  ||


  //Manual Entry Forms
  const enterManually = useRef();
  const [showpatientinfo, setShowPatientInfo] = useState(true);
  const deleteRowModal = useRef();
  const [rowToDelete, setRowToDelete] = useState(null);
  const [manualreportname, setManualReportName] = useState(null);
  const [labTestNames , setLabTestNames] = useState([])
  const [showReportNamesDropdown , setShowReportNamesDropdown] = useState(false)
  const [labTestNamesFiltered , setLabTestNamesFiltered] = useState([]);
  const [showDocNamesDropdown , setShowDocNamesDropdown] = useState(true)
  const [ inputId , setInputId ] = useState("");
  const [boolValForSuggestions , setBoolValForSuggestions] = useState(true);
  const [rows, setRows] = useState([]);

  const [testName, setTestName] = useState("");
  const [selectedTestId, setSelectedTestId] = useState(0);
  const setTestNameInDropDown = (value) =>{
    // console.log(value, " vlaue ")
    // const stringValue = String(value); // Convert value to string
   // setTestName(stringValue);
  //  setPatientInfo((prev) => ({ ...prev, name: value }));
  setManualReportName(value)

    let labTestSelected = labTestNames.find(item => item.testname == value);
    if(labTestSelected){
      setSelectedTestId(labTestSelected.id)
    }
  }


  const handletestNamechange = (e) =>{
    // console.log(value , " value")
    // const stringValue = String(value); // Convert value to string
    setTestName(e.target.value)
  }
  
  const openManualForm = async ()=>{
    setShowPatientInfo(true);
    setShowReportNamesDropdown(false)
    setRows([])
    // setDoctorName("")
    setManualReportName(null)

    try {
      
      let input = {
        // "countryid": getPatientCountryid(),
        "countryid": patientCountryid,
        "patientid": patientId,
       };
       let result = await GetLabTestName(input);
       if(result?.output?.data){
        setLabTestNames(result.output.data)
        setShowTable(false)
        console.log(result , " result ")
       }else{
        setLabTestNames([]);
        console.log("No labs are available for this doctor")
       }
     
    } catch (error) {
      console.error(`Error in getting lab test names`, error);
    }
    // fetchTreatmentTeam();
    enterManually.current.openRight();
  }

  const filterSurgeonNamesReport = ( surgeonName) => {
    const filtered = labTestNames && labTestNames.filter((surgeon) =>
      surgeon.testname?.toLowerCase().includes(surgeonName.toLowerCase())
    );
    setLabTestNamesFiltered(filtered);
    setBoolValForSuggestions(!boolValForSuggestions)  
    console.log(labTestNames, " labTestNames")
    console.log(filtered, " filtered")
    if(filtered){
      setShowReportNamesDropdown(true)
    }
  };

  const handleReportNameChange = (index, surgeonName) => {
    setInputId(index)
    setManualReportName(surgeonName)

    // Filter surgeon names based on input
    if (surgeonName) {
      filterSurgeonNamesReport(surgeonName);
      // alert(surgeonName)
    // setPatientInfo((prev) => ({ ...prev, name: surgeonName }));
    } else {
      
      setLabTestNamesFiltered([]);
      
    setBoolValForSuggestions(!boolValForSuggestions)
    }
  };

  const handleShowListOfTestNames = ( isImage) => {
    console.log('isImage:', isImage)
 
    const allSuggestions = labTestNames && labTestNames
    setLabTestNamesFiltered(allSuggestions);
    setBoolValForSuggestions(!boolValForSuggestions) 
    if(isImage){
      setShowReportNamesDropdown(!showReportNamesDropdown)
      setShowDocNamesDropdown(false)
    }
  };


  const handleSelectReport = (selectedTest) => {
    setSelectedTestId(selectedTest.id)
    setManualReportName(selectedTest.testname);
    setLabTestNamesFiltered([]);
  };

  const [ labTestDetail , setLabTestDetail] = useState([]);
  const SubmitPatientForm = async () => {
    // if(patientInfo.name == ''){
    //   showErrorToast("Please specify your name");
    //    return false;
    //  }else
      if(manualreportname == '' || manualreportname == null){
      showErrorToast("Please provide report name!");
      return false;
    }
    else{
      try {
      
        let input = {
          "labtestid":selectedTestId,
        "countryid": patientCountryid,
        'patientid': patientId
         };
         let result = await GetTestResultByLabTestId(input);
         if(result?.output?.data){
          setLabTestDetail(result.output.data)
          console.log(result , " result ")
          PopulateRows(result.output.data)
         }else{
          setLabTestDetail([]);
          AddAnotherRowLabTest();
          console.log("Something went wrong!")
         }
       
      } catch (error) {
        console.error(`Error in getting lab test names`, error);
      }
      setShowPatientInfo(false)

      //here
    }
  };

  const AddAnotherRowLabTest = () => {
    const initialRow = {
      test_name: '',
      resultvalue: '',
      test_unit: '',
    };
    setRows((prevRows) => [...prevRows, { ...initialRow }]);
    focusInput("LabNameInAdd"); // Focus logic
  };
  const PopulateRows = (testDetail) => {
    if(labTestDetail){
      for(let i = 0; i < testDetail.length; i++){

        const initialRow = {
          test_name: testDetail[i].eventtitle,
          resultvalue: "",
          test_unit: testDetail[i].resultuom,
          "upper_bound": testDetail[i].upperbound,
          "lower_bound": testDetail[i].lowerbound,
        };
        setRows((prevRows) => [...prevRows, { ...initialRow }]);
    }
    }
    focusInput("LabNameInAdd"); // Focus logic
  };

  const focusInput = (inputId) => {
    setTimeout(() => {
      const element = document.getElementById(inputId);
      if (element) {
        element.focus();
      }
    }, 100);
  };

  const confirmDeleteRow = (index) => {
    setRowToDelete(index);
    deleteRowModal.current.openModal();
  };
  const deleteRowHandler = () => {
    const newRows = rows.filter((_, i) => i !== rowToDelete);
    setRows(newRows);
    deleteRowModal.current.closeModal();
  };

  const initialRow = {
    test_name: '',
    resultvalue: '',
    test_unit: '',
  };

  const handleTestNameChange = (name, index) => {
    setInputId(index)
    const newRows = [...rows];
    newRows[index].test_name = name;
    if (!name) {
      newRows[index] = { ...initialRow }; // Reset the entire row if medicine name is cleared
    }
    setRows(newRows);
  };
  const handleTestResultChange = (result, index) => {
    const newRows = [...rows];
    newRows[index].resultvalue = result;
    setRows(newRows);
  };
  const handleunitChange = (unit, index) => {
    const newRows = [...rows];
    newRows[index].test_unit = unit;
    setRows(newRows);
  };

  const SubmitForm = async () => {
      showLoader();
      const isValidRows = (rows, fieldNames) => {
        for (const row of rows) {
          for (const fieldName of fieldNames) {
            if (!row[fieldName]) {
              dismissLoader();
              // Assuming you have a function to show toast messages
              showErrorToast(`Please fill in the ${fieldName == "test_name"? "Test Name": "Result Value"}`);
              return false;
            }
          }
        }
        return true;
      };
      if (!isValidRows(rows, ['test_name', 'resultvalue'])) return;
        let FinalInput = {
          patient_info:{
            // name: getPatientFullName(),
            // age: getPatientAge(),
            // doctor_name: doctorName,
            // date_of_report: patientInfo.date_of_report ? patientInfo.date_of_report : moment().format("YYYY-MM-DD"),
            // hospital_name: patientInfo.hospital_name,
            patientid: patientId,
          },
          report_info:{
            type:"labs",
            name: manualreportname
          },
          test_list: rows.map((row) => ({
            test_name: row.test_name,
            test_unit: row.test_unit,
            resultvalue: row.resultvalue,
            "upper_bound": row.upper_bound,
            "lower_bound": row.lower_bound,
          })),
        };
        showLoader();
        const result = await AddMedicalRecord(FinalInput);
        if (result.output.result === "success") {
          // setShowSuccess(true);
          fetchPatientHealthData()
          showSuccessToast("Report added Successfully!")
          enterManually.current.closeRight();
          //setActiveTab("TableViewTab");
          // setTimeout(() => {
            
          //   window.location.reload()
          // }, 500);
          dismissLoader();
        } else {
          showErrorToast("Somthing went wrong");
          dismissLoader();
        }
    };

    const [showTable, setShowTable] = useState(false);

    return (
      <Box h="100%">
        <Box
          bg="#fcfcfd"
          width={width}
          height={height}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDir='column'
        h='100%'
        gap='1rem'
        >
          {/* <PrimaryButton
            fontSize="14px"
            variant="mdBtn"
            btnIcon="/assets/imgs/add.png"
            buttonText="Add Investigation"
            onClick={openVaccinationsModal}
            isDisabled={actionAccessPatients?.create ? false : true}
          /> */}
           <PrimaryButton
                    fontSize="14px"
                    variant="mdBtn"
                    buttonText="Add Investigation"
                    btnIcon="/assets/imgs/add.png"
                    onClick={openManualForm}
                  />
          {isNoData === "Yes" &&
          <Text textAlign="center">
            No Investigation Data Available
          </Text>
          }
        </Box>
        {/* Add Modal Here  */}
        <ModalRight
          ref={addCondition}
          header="Add vaccine"
          body={
            <>
              <SearchBar
                passInputPlace="Search condition"
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <RadioGroup>
                <Stack direction="column" gap="0">
                  <Box display="flex" justifyContent="end" w="100%">
                    <Stack direction="column" gap="0" w="100%">
                      {conditionsList && conditionsList.length > 0 ? (
                        conditionsList.some((category) =>
                          category.data.some((condition) =>
                            condition.condition
                              .toLowerCase()
                              .includes(searchValue.toLowerCase())
                          )
                        ) ? (
                          conditionsList.map((category) => (
                            <React.Fragment key={category.category_id}>
                              {category.data
                                .filter((condition) =>
                                  condition.condition
                                    .toLowerCase()
                                    .includes(searchValue.toLowerCase())
                                )
                                .map((condition) => (
                                  <label key={condition.condition_cd}>
                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                      borderBottom="1px solid #e2e8f0"
                                      p="15px"
                                      pl="5px"
                                      minH="50px"
                                      width="100%"
                                      sx={{
                                        _hover: {
                                          border: "2px solid #384052",
                                          borderRadius: "10px",
                                        },
                                      }}
                                    >
                                      <Box
                                        key={condition.condition_cd}
                                        display="flex"
                                        alignItems="center"
                                      >
                                        <Text
                                          fontSize="16px"
                                          lineHeight="normal"
                                          fontWeight="600"
                                        >
                                          {condition.condition}
                                        </Text>
                                      </Box>
                                      <Box display="flex" justifyContent="end">
                                        <Checkbox
                                          colorScheme="green"
                                          sx={{
                                            ".chakra-checkbox__control": {
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "5px",
                                            },
                                          }}
                                          onChange={() =>
                                            handleCheckboxChange(condition)
                                          }
                                          isChecked={selectedConditions.some(
                                            (item) =>
                                              item.condition_cd ===
                                              condition.condition_cd
                                          )}
                                        ></Checkbox>
                                      </Box>
                                    </Box>
                                  </label>
                                ))}
                            </React.Fragment>
                          ))
                        ) : (
                          <Box
                            p="15px"
                            fontSize="16px"
                            fontWeight="600"
                            textAlign="center"
                          >
                            No matching vaccinations found!
                          </Box>
                        )
                      ) : (
                        <p>Loading...</p>
                      )}
                      <Divider />
                      <br />
                      <Heading
                        as="h2"
                        fontSize="12px"
                        pl="5px"
                        textTransform="uppercase"
                        fontWeight="600"
                        my="10px"
                      >
                        Other Vaccination
                      </Heading>
                      <PrimaryInput
                        inputPlace="Vaccination"
                        variant="bothSide"
                        onChange={handleCondition}
                        inputValue={typedCondition}
                      />
                      <br />
                    </Stack>
                  </Box>
                </Stack>
              </RadioGroup>

              <ModalRight
                ref={addCondition2}
                header="Add Vaccination"
                body={
                  <>
                    <Box display="flex" flexDir="column" gap="20px">
                      {selectedConditions.map((condition, index) => (
                        <Box key={index}>
                          <Text fontSize="16px" py="10px" fontWeight="600">
                            {condition.condition}
                          </Text>

                          {/* <DatePicker
                            disableFutureDates={true}
                            //minDate={null}
                            maxDate={maxDateState}
                            onDateChange={(selectedDateValue) =>
                              handleDateChange(
                                condition.condition_cd,
                                selectedDateValue
                              )
                            }
                            placeholderProp="Admin Date*"
                          /> */}

                          <DatePickerQuick
                            disableFutureDates={true}
                            // patientDOB={PatientDOB}
                            maxDate={maxDateState}
                            CUSTOM_DISABLE={true}
                            placeholderProp="Select Admin Date*"
                            // defaultDate={todaysDate}
                            onDateChange={(selectedDateValue) =>
                              handleDateChange(
                                condition.condition_cd,
                                selectedDateValue
                              )
                            }
                            calendarStlye={{
                              transform: "scale(0.9)",
                              right: "-22px",
                              top: "30px",
                            }}
                          />

                          {/* <DatePicker
                            disablePastDates={true}
                            //minDate={minDateState}
                            onDateChange={(selectedDateValue) =>
                              handleDueDateChange(
                                condition.condition_cd,
                                selectedDateValue
                              )
                            }
                            placeholderProp="Due Date"
                            minDate={new Date().toISOString()}
                          /> */}

                          <DatePickerQuick
                            disablePastDates={true}
                            // patientDOB={PatientDOB}
                            CUSTOM_DISABLE={true}
                            placeholderProp="Select Due Date"
                            minDate={new Date().toISOString()}
                            // defaultDate={todaysDate}
                            onDateChange={(selectedDateValue) =>
                              handleDueDateChange(
                                condition.condition_cd,
                                selectedDateValue
                              )
                            }
                            calendarStlye={{
                              transform: "scale(0.9)",
                              right: "-22px",
                              top: "30px",
                            }}
                          />

                          
                  {/* Upload document JSX start ---------- */}
{documentURLs?.map((document, index) => {
                        if (document.condition_cd == condition.condition_cd || (document.condition_cd == null && condition.condition_cd == null)) {
                          if (!indexMap[document.condition_cd]) {
                            indexMap[document.condition_cd] = 1;
                          }
                          const docIndex = indexMap[document.condition_cd];
                          indexMap[document.condition_cd]++; // Increment index for next document with same condition_cd

                          return (
                            <Box key={index} mb="2" mt="2">
                              <Button
                                as="a"
                                rel="noopener noreferrer"
                                w="100%"
                                h="48px"
                                borderRadius="10px"
                                border="1px solid #E6E7E9"
                                display="flex"
                                justifyContent="space-between"
                                bg="white"
                                color="#1C4EC5"
                                sx={{ _hover: { bg: "none" } }}
                                style={{
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  textOverflow: "ellipsis",
                                  fontSize: "12px",
                                }}
                              >
                                Document {docIndex}
                                <Box as="span" onClick={() => handleDelete(index)}>
                                  <Image src="/assets/imgs/delete.png" />
                                </Box>
                              </Button>
                            </Box>
                          );
                        }
                      })}
                      <Box 
                      onClick={() => addVaccineUploadDocument(condition)} 
                      as="button" display="flex" alignItems="center" gap="10px" mt="5px" fontSize="14px" fontWeight="600" color="#1C4EC5" textAlign="left">
                        <Image w="11px" src="/assets/imgs/add-blue.png" />
                        Add Document
                      </Box>

                      <input
                        type='file'
                        id='file-upload'
                        onChange={(e) => handleVaccineUpload(e)}
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                      />

                      
                      {/* Upload document JSX End ---------- |||||| */}
                
                        </Box>
                      ))}
                    </Box>
                  </>
                }
                footerActions={
                  <>
                    <Box w="100%" display="flex" flexDirection="row" gap="15px">
                      <PrimaryButton
                        buttonText="Add Vaccine"
                        isDisabled={actionAccessPatients?.create ? false : true}
                        onClick={AddMedicalConditionsCall}
                      />
                    </Box>
                  </>
                }
              />
            </>
          }
          footerActions={
            <>
              <Box w="100%" display="flex" flexDirection="row" gap="15px">
                <PrimaryButton
                  buttonText="Continue"
                  isDisabled={false}
                  onClick={AddMedicalConditions}
                />
              </Box>
            </>
          }
        />

{/* Original Code modal */}
{/* <ModalRight
        ref={enterManually}
        modalWidth={showpatientinfo ? "600px": "70vw"}
        bodyStyle={{ overflow: "hidden" }}
        header="Add Investigation"
        hasFooter={true}
        body={
          <>
          {showpatientinfo ?(
            <Box overflowY="auto" p="24px" h="100%">
<Box display="flex" alignItems="center" position="relative">
<PrimaryInput
              variant="bothSide"
              inputType="text"
              inputPlace="Report Name*"
              inputValue={manualreportname}
              onChange={(e) =>
                handleReportNameChange(2, handleAlphaDotAndSpace(e.target.value, 50))
              }
              onClick={() =>
                handleShowListOfTestNames(true)
              } 
              inputIdProp={inputId == 2 ? "Active" : null}
              boolProp={boolValForSuggestions}
            /> 
               <Image top="35%" right="3.5%" w="15px"  cursor="pointer" position="absolute"
                          onClick={() =>
                            handleShowListOfTestNames( true)
                          }
                            pos='absolute' src="/assets/imgs/double-arrow.png" />
          </Box>
                          
                    {showReportNamesDropdown &&  labTestNamesFiltered.length > 0 && (
                <Menu isOpen={true}>
                <MenuButton as={Box} w="100%" display="block" pos="relative" zIndex="999">
                  <Box pos="absolute" top="100%" left="0" w="100%" bg="white" borderTop="none" border="1px solid #E6E7E9" borderRadius="0 0 12px 12px" />
                </MenuButton>
                <MenuList w="100%" borderRadius="0 0 12px 12px" zIndex="999" bg="white" maxH="150px" overflow="hidden auto">
                  {labTestNamesFiltered.map((suggestion, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => handleSelectReport(suggestion)}
                      cursor="pointer"
                      p="1rem"
                      py="0.5rem"
                      borderBottom="1px solid #E6E7E9"
                    >
                      <Text fontSize="0.875rem" fontWeight="500">{suggestion.testname}</Text>
                    </MenuItem>
                  ))}
                  </MenuList>
                </Menu>
              )}
          </Box>
          ):(
            <SimpleTableInvestigation
                NoDataHeader={false}
                isDataPresent={true}
                ThStyle={{ textAlign: "center", bg: "#FAFAFA" }}
                tableStyle={{
                  h: "calc(100vh - 170px)",
                  maxH: "calc(100vh - 170px)",
                  overflowY: "auto",
                  overflowX: "hidden",
                  width: "100%",
                  border: "1px solid #E6E7E9",
                  borderBottom: "none",
                }}
                tableHeaders={
                  <Tr bg='white' zIndex='9999' pos='relative'>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Test name
                    </Th><Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Unit
                    </Th>
                    <Th fontSize="0.87rem" fontWeight="500" pl="10px">
                      Result
                    </Th>
                    <Th fontSize="0.87rem" fontWeight="500" >
                      <Flex w="100%" justifyContent="center" alignItems="center">
                        <PrimaryButton
                          btnIcon="/assets/svgs/add-white.svg"
                          iconSrc={true}
                          btnStyle={{ w: "25px", h: "25px", p: "0",m:"0" }}
                          iconSrcStyle={{ mr: "0", w: "10px" }}
                          onClick={AddAnotherRowLabTest}
                        />
                      </Flex>
                    </Th>
                  </Tr>
                }
                tableBody={
                  <>
                    {rows?.map((row, index) => (
                      <Tr w="100%">
                        <Td p="0">
                          <Box w="100%" pos="relative" cursor="pointer">
                            <PrimaryInput
                              variant="bothSide"
                              inputPlace="Test name"
                              inputValue={row.test_name}
                              id="LabNameInAdd"
                              onChange={(e) =>
                                handleTestNameChange(
                                  e.target.value,
                                  index
                                )
                              }
                              autocomplete="off"
                              inputCssStyle={{
                                _hover: {
                                  border: "1px solid",
                                  borderRadius: "10px",
                                },
                              }}
                              maxLength={100}
                            />
                          </Box>
                        
                        </Td>
                        <Td p="0">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace='Unit'
                            inputValue={row.test_unit}
                            onChange={(e) =>
                              handleunitChange(e.target.value, index)
                            }
                            
                            maxLength={10}
                            inputCssStyle={{
                              _hover: { border: "1px solid", borderRadius: "10px" },
                            }}
                          />
                        </Td>

                        <Td p="0">
                          <PrimaryInput
                            variant="bothSide"
                            inputPlace="Result"
                            inputValue={row.resultvalue}
                            onChange={(e) =>
                              handleTestResultChange(e.target.value, index)
                            }
                            inputCssStyle={{
                              _hover: { border: "1px solid", borderRadius: "10px" },
                            }}
                            //isDisabled={true}
                            maxLength={30}
                          />
                        </Td>
                  

                        <Td p="0">
                          <Box
                            as="button"
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            w="100%"
                             onClick={() => confirmDeleteRow(index)}
                          >
                            <Image src="/assets/svgs/delete.svg" opacity="0.7" />
                          </Box>
                        </Td>
                      </Tr>
                      
                     ))} 
                  </>
                }
            />
          )}
          </>
        }
        footerActions={
          <>
          {showpatientinfo ?(
            <PrimaryButton buttonText="Next" 
            onClick={SubmitPatientForm}
            />
          ):(
            <PrimaryButton buttonText="Submit" 
            onClick={SubmitForm}
            />
          )}
          </>
        }
      /> */}
      <DynamicModal
        ref={deleteRowModal}
        modalHeader="Delete row"
        modalBody={
          <>
            <Text fontSize="14px" fontWeight="600">
              Are you sure you want to delete?
            </Text>
          </>
        }
        modalFooterBtn={
          <>
            <PrimaryButton
              variant="deleteBtn"
              buttonText="Delete"
              onClick={deleteRowHandler}
            />
          </>
        }
      />

<ModalRight
  ref={enterManually}
  // modalWidth={showpatientinfo ? "600px" : "70vw"}
  modalWidth="600px"
  bodyStyle={{ overflow: "hidden" }}
  header="Add Investigation"
  hasFooter={true}
  body={
    <Box overflowY="auto" p="24px 0 24px" h="100%" display="flex" flexDirection="column">
      {/* Report Name Input Section */}
      <Box display="flex" alignItems="center" position="relative" mb={4}>
        <PrimaryInput
          variant="bothSide"
          inputType="text"
          inputPlace="Report Name*"
          inputValue={manualreportname}
          onChange={(e) =>
            handleReportNameChange(2, handleAlphaDotAndSpace(e.target.value, 50))
          }
          onClick={() => {
            handleShowListOfTestNames(true)
            setRows([]);
          }}
          inputIdProp={inputId == 2 ? "Active" : null}
          boolProp={boolValForSuggestions}
          width="calc(100% - 100px)" // Adjust width to accommodate button
        />
        <Image 
          top="35%" 
          right="calc(3.5% + 100px)" 
          w="15px"  
          cursor="pointer" 
          position="absolute"
          onClick={() => {
            handleShowListOfTestNames(true)
            setShowTable(false)
            setRows([]);
          }}
          src="/assets/imgs/double-arrow.png" 
        />
        
        {/* Next Button in the same row */}
        <PrimaryButton 
          buttonText="Next" 
          // onClick={SubmitPatientForm}
          onClick={() => {
            SubmitPatientForm();
            setShowTable(manualreportname !== ""); // Only show table if report name exists
          }}
          ml={2}
          width="80px"
          height="40px"
          isDisabled={!manualreportname} // Disable if no report name
        />
      </Box>
      
      {/* Report Names Dropdown */}
      {showReportNamesDropdown && labTestNamesFiltered.length > 0 && (
        <Menu isOpen={true}>
          <MenuButton as={Box} w="100%" display="block" pos="relative" zIndex="999">
            <Box pos="absolute" top="100%" left="0" w="100%" bg="white" borderTop="none" border="1px solid #E6E7E9" borderRadius="0 0 12px 12px" />
          </MenuButton>
          <MenuList w="100%" borderRadius="0 0 12px 12px" zIndex="999" bg="white" maxH="150px" overflow="hidden auto">
            {labTestNamesFiltered.map((suggestion, index) => (
              <MenuItem
                key={index}
                onClick={() => handleSelectReport(suggestion)}
                cursor="pointer"
                p="1rem"
                py="0.5rem"
                borderBottom="1px solid #E6E7E9"
              >
                <Text fontSize="0.875rem" fontWeight="500">{suggestion.testname}</Text>
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      )}
      
      {/* Test List Table - Only shown after report name is selected */}
      {showTable && (
      <Box flex="1" overflowY="auto" mt={4}>
        <Box>
        <Text fontSize="1rem" fontWeight="600" mb='0.875rem'>{manualreportname}</Text>
        {/* <Text fontSize="0.875rem" fontWeight="500">{suggestion.testname}</Text> */}

        </Box>
        <SimpleTableInvestigation
          NoDataHeader={false}
          isDataPresent={true}
          ThStyle={{ textAlign: "center", bg: "#FAFAFA" }}
          tableStyle={{
            h: "auto",
            maxH: "calc(100vh - 300px)",
            overflowY: "auto",
            overflowX: "hidden",
            width: "100%",
            border: "1px solid #E6E7E9",
            borderBottom: "none",
          }}
          tableHeaders={
            <Tr bg='white' zIndex='9999' pos='relative'>
              <Th fontSize="0.87rem" fontWeight="500" pl="10px">Test name</Th>
              <Th fontSize="0.87rem" fontWeight="500" pl="10px">Unit</Th>
              <Th fontSize="0.87rem" fontWeight="500" pl="10px">Result</Th>
              <Th fontSize="0.87rem" fontWeight="500">
                <Flex w="100%" justifyContent="center" alignItems="center">
                  <PrimaryButton
                    btnIcon="/assets/svgs/add-white.svg"
                    iconSrc={true}
                    btnStyle={{ w: "25px", h: "25px", p: "0", m: "0" }}
                    iconSrcStyle={{ mr: "0", w: "10px" }}
                    onClick={AddAnotherRowLabTest}
                  />
                </Flex>
              </Th>
            </Tr>
          }
          tableBody={
            <>
              {rows?.map((row, index) => (
                <Tr w="100%">
                  <Td p="0">
                    <Box w="100%" pos="relative" cursor="pointer">
                      <PrimaryInput
                        variant="bothSide"
                        inputPlace="Test name"
                        inputValue={row.test_name}
                        id="LabNameInAdd"
                        onChange={(e) => handleTestNameChange(e.target.value, index)}
                        autocomplete="off"
                        inputCssStyle={{
                          _hover: {
                            border: "1px solid",
                            borderRadius: "10px",
                          },
                        }}
                        maxLength={100}
                      />
                    </Box>
                  </Td>
                  <Td p="0">
                    <PrimaryInput
                      variant="bothSide"
                      inputPlace='Unit'
                      inputValue={row.test_unit}
                      onChange={(e) => handleunitChange(e.target.value, index)}
                      maxLength={10}
                      inputCssStyle={{
                        _hover: { border: "1px solid", borderRadius: "10px" },
                      }}
                    />
                  </Td>
                  <Td p="0">
                    <PrimaryInput
                      variant="bothSide"
                      inputPlace="Result"
                      inputValue={row.resultvalue}
                      onChange={(e) => handleTestResultChange(e.target.value, index)}
                      inputCssStyle={{
                        _hover: { border: "1px solid", borderRadius: "10px" },
                      }}
                      maxLength={30}
                    />
                  </Td>
                  <Td p="0">
                    <Box
                      as="button"
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      w="100%"
                      onClick={() => confirmDeleteRow(index)}
                    >
                      <Image src="/assets/svgs/delete.svg" opacity="0.7" />
                    </Box>
                  </Td>
                </Tr>
              ))}
            </>
          }
        />
      </Box>
      )}
    </Box>
  }
  footerActions={
    showTable && (
      <PrimaryButton buttonText="Submit" onClick={SubmitForm} />

    )
  }
/>


      </Box>
    );
  }
);

export default NoInvestigationDataScreen;
